import { render, staticRenderFns } from "./BaseSteps.vue?vue&type=template&id=28b57e2e&"
import script from "./BaseSteps.vue?vue&type=script&lang=js&"
export * from "./BaseSteps.vue?vue&type=script&lang=js&"
import style0 from "./BaseSteps.vue?vue&type=style&index=0&id=28b57e2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports